(ns common.entity-utils
  (:require
   [cognitect.transit :as t]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [common.number-utils :as nu]
   [common.schema.calculated-field :as calculated-field]))

(defn get-single-value-
  [tenant tenant-schema entity attribute entity-lookup reverse-lookup]
  (let [field-schema (registry/get-field-schema tenant-schema attribute)
        calc-function (:field/calculated-field field-schema)]
    (if (fn? calc-function)
      (calculated-field/calculate
       {:calc-fn          calc-function
        :entity-data      entity
        :entity-lookup    entity-lookup
        :reverse-lookup   reverse-lookup
        :bigdec->float    nu/bigdec->float
        :float->bigdec    nu/float->bigdec
        :resolve-value    (partial get-single-value- tenant)
        :tr               loc/tr
        :get-field-schema (partial registry/get-field-schema tenant-schema)
        :display-string   entity/display-string})
      (get entity attribute))))

(defn get-value
  [tenant tenant-schema entity attributes entity-lookup reverse-lookup]
  (let [res
        (cond
          (keyword? attributes)
          (get-single-value- tenant tenant-schema entity attributes entity-lookup reverse-lookup)
          (and (coll? attributes) (seq attributes))
          (loop [entity entity
                 [attribute & attributes] attributes]
            (let [value
                  (get-single-value- tenant
                                     tenant-schema
                                     entity
                                     attribute
                                     entity-lookup
                                     reverse-lookup)]
              (if (or (empty? attributes)
                      (nil? value))
                value
                (recur (entity-lookup value) attributes))))
          :else
          nil)]
    res))
